import React from "react";
import { Image, Loader, Button } from "@fluentui/react-northstar";
import uf from "usefuljs";
import {ScreenshotRes} from "@interfaces/acc";
import styles from "./screenshot.module.scss";
import Tag from "./Tag";

type ScreenshotProp = {
    user_acc:string
}

const Screenshot = (props:ScreenshotProp)=>{
    const [img,setImg] = React.useState("");
    const [loading,setLoading] = React.useState<boolean>(false);

    const updateImg = React.useCallback(async()=>{
        setLoading(true);
        const res = await uf.ajax<ScreenshotRes>({
            url: "https://jennysss.lenx.ai/fbm/api/check/screenshot",
            data: {
                fb_acc: props.user_acc
            }
        }).finally(()=>{setLoading(false)});
        if(res.screenshot){ setImg(res.screenshot) }
    },[props]);

    React.useEffect(()=>{
        updateImg();
    },[updateImg]);

    return (
        <div id={styles.screenshot}>
            <h3>{props.user_acc}</h3>
            { loading && <Loader label="Loading screenshot ..." /> }
            { (!loading && img) && 
                <>
                    <Image src={img ? `data:image/png;base64, ${img}` : undefined} alt={"screenshot"} />
                    <div>
                        <Button content="Refresh" onClick={updateImg} />
                        <Tag image={img} />
                    </div>
                </>
            }
            
        </div>
    )
}

export default Screenshot;
